import styled from 'styled-components';
import { device, fontFamily, minDevice } from '../../constants';
import { BodyContainer as BodyContainerTemp } from '../../component/Common/CommonStyles';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  height: 100%;
  display: flex;
  overflow-y: scroll;
  /* padding: 0 2.2rem; */
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media ${device.tablet} {
    justify-content: space-between;
  }
`;

export const ItemContainer = styled.div`
  background: #ffffff;
  width: 100%;
  /* height: 10rem; */
  margin: 1rem;
  padding: 2rem;
  box-shadow: -5px -5px 11px #fffffff5;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  @media ${minDevice.tablet} {
    flex: 0 1 48%;
  }

  /* flex: 1; */
  /* max-width: 20%; */
`;

export const HeaderText = styled.div`
  font-size: 3rem;
  font-family: ${fontFamily.circularMedium};
  color: #4a4a4a;
  flex: 0 1 40%;
  @media ${device.mobileL} {
    font-size: 2rem;
  }
  ${'' /* width: 25rem; */}/* width: 100%; */
`;

export const CountText = styled.div`
  font-size: 8rem;
  font-family: ${fontFamily.circularMedium};
  color: ${({ color }) => color || '#4f4ed0'};

  margin-bottom: 2rem;

  @media ${device.mobileL} {
    font-size: 6rem;
    margin-bottom: 1.5rem;
  }
`;
